<template>
  <Teleport to="body">
    <div class="toast-host" aria-live="polite" aria-atomic="false">
      <CvToastNotification
        v-for="t in toasts"
        :key="t.id"
        :kind="t.kind"
        :title="t.title"
        :sub-title="t.caption"
        low-contrast
        @close="dismiss(t.id)"
      >
        <!-- Render the action in the subtitle slot so it sits directly under
             the title; the default slot lands below the (always-rendered, here
             empty) subtitle + caption divs, which pushes it to the bottom. -->
        <template v-if="t.action" #subtitle>
          <button type="button" class="toast-host__action" @click="t.action.handler">
            {{ t.action.label }}
          </button>
        </template>
      </CvToastNotification>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { CvToastNotification } from '@carbon/vue'
import { useToast } from '@/composables/useToast'

const { toasts, dismiss } = useToast()
</script>

<style scoped lang="scss">
.toast-host {
  position: fixed;
  top: var(--space-5, 20px);
  right: var(--space-5, 20px);
  z-index: 9000;
  display: flex;
  flex-direction: column;
  gap: var(--space-3, 12px);
  pointer-events: none;

  :deep(.bx--toast-notification),
  :deep(.cv-toast-notification) {
    pointer-events: auto;
  }
}

// Inline action (e.g. "Undo"), rendered in the subtitle slot. Carbon has no
// styled button there, so render a borderless, underlined affordance that
// inherits the toast's low-contrast foreground.
.toast-host__action {
  margin-top: var(--space-3, 12px);
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}
</style>
